'use client';

import React from 'react';
import { Printer } from 'lucide-react';

export default function PrintRunningOrder() {
  const handlePrint = () => {
    const html = `<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8" />
  <title>George &amp; Boadecea — Running Order</title>
  <style>
    @page { size: A4 portrait; margin: 18mm 16mm 14mm 16mm; }
    * { box-sizing: border-box; margin: 0; padding: 0; }
    body {
      font-family: 'DM Sans', Arial, sans-serif;
      color: #2C3E50;
      font-size: 9pt;
      background: #fff;
    }
    .header {
      text-align: center;
      margin-bottom: 18pt;
      border-bottom: 0.5pt solid #C8B89A;
      padding-bottom: 12pt;
    }
    .header h1 {
      font-family: 'Cormorant Garamond', Georgia, serif;
      font-size: 22pt;
      color: #2C3E50;
      letter-spacing: 0.04em;
      margin-bottom: 2pt;
      font-weight: 400;
    }
    .header p {
      font-size: 8pt;
      letter-spacing: 0.2em;
      text-transform: uppercase;
      color: #8C7B6B;
    }
    table {
      width: 100%;
      border-collapse: collapse;
      margin-bottom: 14pt;
    }
    thead tr {
      border-bottom: 0.5pt solid #C8B89A;
    }
    th {
      font-size: 7pt;
      letter-spacing: 0.18em;
      text-transform: uppercase;
      color: #8C7B6B;
      text-align: left;
      padding-bottom: 5pt;
      font-weight: 400;
    }
    th.col-time { width: 14%; }
    th.col-event { width: 30%; }
    td {
      padding: 5pt 6pt 5pt 0;
      vertical-align: top;
      border-bottom: 0.3pt solid #E8E0D5;
      font-size: 8pt;
      color: #5A5A5A;
      line-height: 1.45;
    }
    td.time {
      font-family: 'Cormorant Garamond', Georgia, serif;
      font-size: 9pt;
      color: #2C3E50;
      padding-right: 6pt;
    }
    td.event {
      font-size: 8.5pt;
      color: #2C3E50;
      padding-right: 8pt;
    }
    td.loc .place { color: #2C3E50; }
    td.loc .note { color: #8C7B6B; font-size: 7.5pt; }
    .highlight td { font-weight: 600; }
    .day-header td {
      padding-top: 10pt;
      padding-bottom: 3pt;
      border-bottom: none;
    }
    .day-header td p {
      font-family: 'Cormorant Garamond', Georgia, serif;
      font-size: 11pt;
      color: #2C3E50;
      font-style: italic;
    }
    .notes-grid {
      border-top: 0.5pt solid #C8B89A;
      padding-top: 8pt;
      margin-bottom: 12pt;
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 12pt;
    }
    .notes-grid .label {
      font-size: 7pt;
      letter-spacing: 0.18em;
      text-transform: uppercase;
      color: #8C7B6B;
      margin-bottom: 3pt;
    }
    .notes-grid .value {
      font-size: 8pt;
      color: #5A5A5A;
      line-height: 1.5;
    }
    .map-section {
      border-top: 0.5pt solid #C8B89A;
      padding-top: 8pt;
    }
    .map-label {
      font-size: 7pt;
      letter-spacing: 0.18em;
      text-transform: uppercase;
      color: #8C7B6B;
      margin-bottom: 6pt;
    }
    .map-frame {
      width: 100%;
      height: 220pt;
      border: 0.5pt solid #C8B89A;
      display: block;
    }
    .legend {
      display: flex;
      gap: 14pt;
      margin-top: 5pt;
      flex-wrap: wrap;
    }
    .legend-item {
      display: flex;
      align-items: center;
      gap: 4pt;
    }
    .legend-dot {
      width: 8pt;
      height: 8pt;
      border-radius: 50%;
      flex-shrink: 0;
    }
    .legend-item span {
      font-size: 7pt;
      color: #5A5A5A;
    }
    .footer-note {
      font-size: 6.5pt;
      color: #9B9B9B;
      margin-top: 4pt;
    }
    .map-locations {
      margin-top: 8pt;
      border: 0.5pt solid #C8B89A;
      padding: 8pt;
    }
    .map-locations-title {
      font-size: 7pt;
      letter-spacing: 0.18em;
      text-transform: uppercase;
      color: #8C7B6B;
      margin-bottom: 6pt;
    }
    .location-row {
      display: flex;
      gap: 8pt;
      margin-bottom: 4pt;
      align-items: flex-start;
    }
    .location-dot {
      width: 8pt;
      height: 8pt;
      border-radius: 50%;
      flex-shrink: 0;
      margin-top: 1pt;
    }
    .location-text {
      font-size: 7.5pt;
      color: #5A5A5A;
      line-height: 1.4;
    }
    .location-text strong {
      color: #2C3E50;
    }
  </style>
</head>
<body>
  <div class="header">
    <h1>George &amp; Boadecea</h1>
    <p>Saturday 29th August 2026 &middot; Dartmouth, Devon</p>
  </div>

  <table>
    <thead>
      <tr>
        <th class="col-time">Time</th>
        <th class="col-event">Event</th>
        <th>Location &amp; Notes</th>
      </tr>
    </thead>
    <tbody>
      <!-- Friday -->
      <tr class="day-header">
        <td colspan="3"><p>Friday 28th August &mdash; The Eve</p></td>
      </tr>
      <tr>
        <td class="time">17:00&ndash;19:30</td>
        <td class="event">Evening Gathering <span style="font-size:7.5pt;color:#8C7B6B;">(optional)</span></td>
        <td class="loc"><span class="place">Galions Quay</span><br/><span class="note">A house near Dartmouth Castle &middot; Castle Rd, Dartmouth TQ6 0JN &middot; Parking very limited</span></td>
      </tr>
      <tr>
        <td class="time">19:00</td>
        <td class="event">Regatta Festivities</td>
        <td class="loc"><span class="place">Dartmouth Town</span><br/><span class="note">A short walk from Galions Quay &mdash; soak up the atmosphere ahead of the big day</span></td>
      </tr>

      <!-- Saturday -->
      <tr class="day-header">
        <td colspan="3"><p>Saturday 29th August &mdash; The Wedding Day</p></td>
      </tr>
      <tr>
        <td class="time">11:00</td>
        <td class="event">Travel to Church</td>
        <td class="loc"><span class="place">Dartmouth Quayside to St Petrox Church</span><br/><span class="note">Passenger ferry (approximately 15 min) or on foot (approximately 25&ndash;30 min). Please allow plenty of time &mdash; the ferry could be busy. We recommend using the park and ride &mdash; parking in Dartmouth will be very limited due to the Regatta.</span></td>
      </tr>
      <tr class="highlight">
        <td class="time">12:00</td>
        <td class="event">Wedding Ceremony</td>
        <td class="loc"><span class="place">St Petrox Church, Dartmouth Castle</span><br/><span class="note">Castle Road, Dartmouth TQ6 9JH &middot; Please be seated by 11:30</span></td>
      </tr>
      <tr>
        <td class="time">Post-ceremony</td>
        <td class="event">Refreshments &amp; Photographs</td>
        <td class="loc"><span class="place">Castle Cove</span><br/><span class="note">5&ndash;10 min walk from church via coastal path &middot; Steps down to the cove; seating available at the top</span></td>
      </tr>
      <tr class="highlight">
        <td class="time">15:00</td>
        <td class="event">Wedding Reception</td>
        <td class="loc"><span class="place">Gullsway Boathouse, Dartmouth</span><br/><span class="note">Waterfront venue &middot; gullsway.co.uk &middot; Entrance from South Town road (steps down). Boat pick-up available after 15:30 &mdash; let us know in advance.</span></td>
      </tr>
      <tr>
        <td class="time">21:00</td>
        <td class="event">Dartmouth Regatta Fireworks</td>
        <td class="loc"><span class="place">Dartmouth Waterfront</span><br/><span class="note">Visible from Gullsway Boathouse and the Embankment</span></td>
      </tr>
      <tr>
        <td class="time">21:00</td>
        <td class="event">Party Continues at Gullsway Boathouse</td>
        <td class="loc"><span class="place">Gullsway Boathouse, Dartmouth</span><br/><span class="note">Carriages and boats at 23:00</span></td>
      </tr>
      <tr>
        <td class="time">23:00</td>
        <td class="event">After-Party in Dartmouth Town</td>
        <td class="loc"><span class="place">Dartmouth Town</span><br/><span class="note">5-minute walk into town</span></td>
      </tr>

      <!-- Sunday -->
      <tr class="day-header">
        <td colspan="3"><p>Sunday 30th August &mdash; The Morning After</p></td>
      </tr>
      <tr>
        <td class="time">10:00 onwards</td>
        <td class="event">Morning on the Beach</td>
        <td class="loc"><span class="place">Blackpool Sands</span><br/><span class="note">A379, Stoke Fleming TQ6 0RG &middot; 10 mins from Dartmouth &middot; Caf&eacute; open for refreshments or bring a picnic &middot; Cold water dip &amp; beach sauna &middot; Kayaks &amp; paddleboards to hire (book ahead)</span></td>
      </tr>
      <tr>
        <td class="time">15:00</td>
        <td class="event">A few options</td>
        <td class="loc"><span class="place">Dartmouth</span><br/><span class="note">We&rsquo;ll see what everyone feels like &mdash; perhaps a cliff walk, a visit to the tropical gardens, or longer on the beach if the weather is good. Meeting point to be confirmed.</span></td>
      </tr>
    </tbody>
  </table>

  <div class="notes-grid">
    <div>
      <p class="label">Getting There</p>
      <p class="value">Nearest station: Totnes (approximately 12 miles). By car: TQ6 9PH. Passenger ferry from Dartmouth Embankment to Kingswear. We recommend using the park and ride on Saturday due to the Regatta.</p>
    </div>
  </div>

  <div class="map-section">
    <p class="map-label">Dartmouth &amp; Key Locations</p>
    <div id="print-map" style="width:100%;height:220pt;position:relative;overflow:hidden;border:0.5pt solid #C8B89A;background:#e8e0d8;"></div>
    <div class="legend">
      <div class="legend-item"><div class="legend-dot" style="background:#2C3E50;"></div><span>1 &mdash; St Petrox Church (Ceremony · 12:00)</span></div>
      <div class="legend-item"><div class="legend-dot" style="background:#C8B89A;border:1px solid #aaa;"></div><span>2 &mdash; Castle Cove (Post-ceremony refreshments)</span></div>
      <div class="legend-item"><div class="legend-dot" style="background:#7A8C5E;"></div><span>3 &mdash; Gullsway Boathouse (Reception · 15:00)</span></div>
      <div class="legend-item"><div class="legend-dot" style="background:#4A90A4;"></div><span>4 &mdash; Ferry Departs Dartmouth</span></div>
      <div class="legend-item"><div class="legend-dot" style="background:#A0522D;"></div><span>5 &mdash; Galions Quay (Friday evening · 17:00)</span></div>
    </div>
    <p class="footer-note">Map &copy; OpenStreetMap contributors. All locations are approximate. georgeandboadecea.com</p>
  </div>
</body>
<script>
(function() {
  var ZOOM = 15;
  var MAP_CENTER = { lat: 50.3455, lng: -3.5710 };
  var locations = [
    { number: '1', name: 'St Petrox Church', color: '#2C3E50', lat: 50.34227473333068, lng: -3.566364372086177, labelBelow: false },
    { number: '2', name: 'Castle Cove',       color: '#C8B89A', lat: 50.34145608189964, lng: -3.5656146192656726, labelBelow: true },
    { number: '3', name: 'Gullsway Boathouse',color: '#7A8C5E', lat: 50.34680140004612, lng: -3.5771414577019183, labelBelow: false },
    { number: '4', name: 'Ferry Departs',     color: '#4A90A4', lat: 50.35036797119165, lng: -3.5772246789810374, labelBelow: false },
    { number: '5', name: 'Galions Quay',      color: '#A0522D', lat: 50.34315009722705, lng: -3.569736151836803,  labelBelow: false },
  ];

  function lngToTileX(lng, zoom) { return ((lng + 180) / 360) * Math.pow(2, zoom); }
  function latToTileY(lat, zoom) {
    var r = (lat * Math.PI) / 180;
    return ((1 - Math.log(Math.tan(r) + 1 / Math.cos(r)) / Math.PI) / 2) * Math.pow(2, zoom);
  }
  function latLngToPixel(lat, lng, cLat, cLng, zoom, w, h) {
    var ts = 256;
    var cx = lngToTileX(cLng, zoom) * ts, cy = latToTileY(cLat, zoom) * ts;
    var px = lngToTileX(lng, zoom) * ts,  py = latToTileY(lat, zoom) * ts;
    return { x: w / 2 + (px - cx), y: h / 2 + (py - cy) };
  }

  var container = document.getElementById('print-map');
  if (!container) return;
  var w = container.offsetWidth || 595;
  var h = container.offsetHeight || 295;

  var tileSize = 256;
  var cTX = lngToTileX(MAP_CENTER.lng, ZOOM);
  var cTY = latToTileY(MAP_CENTER.lat, ZOOM);
  var tilesX = Math.ceil(w / tileSize) + 2;
  var tilesY = Math.ceil(h / tileSize) + 2;
  var startTX = Math.floor(cTX) - Math.floor(tilesX / 2);
  var startTY = Math.floor(cTY) - Math.floor(tilesY / 2);
  var offX = w / 2 - (cTX - Math.floor(cTX)) * tileSize - Math.floor(tilesX / 2) * tileSize;
  var offY = h / 2 - (cTY - Math.floor(cTY)) * tileSize - Math.floor(tilesY / 2) * tileSize;
  var maxTile = Math.pow(2, ZOOM);

  for (var i = 0; i < tilesX; i++) {
    for (var j = 0; j < tilesY; j++) {
      var tx = startTX + i;
      var ty = startTY + j;
      var wtx = ((tx % maxTile) + maxTile) % maxTile;
      var img = document.createElement('img');
      img.src = 'https://tile.openstreetmap.org/' + ZOOM + '/' + wtx + '/' + ty + '.png';
      img.style.cssText = 'position:absolute;left:' + (offX + i * tileSize) + 'px;top:' + (offY + j * tileSize) + 'px;width:' + tileSize + 'px;height:' + tileSize + 'px;pointer-events:none;';
      img.draggable = false;
      container.appendChild(img);
    }
  }

  locations.forEach(function(loc) {
    var pos = latLngToPixel(loc.lat, loc.lng, MAP_CENTER.lat, MAP_CENTER.lng, ZOOM, w, h);
    var wrapper = document.createElement('div');
    wrapper.style.cssText = 'position:absolute;left:' + pos.x + 'px;top:' + pos.y + 'px;transform:' + (loc.labelBelow ? 'translate(-50%,-50%)' : 'translate(-50%,-100%)') + ';z-index:10;display:flex;flex-direction:column;align-items:center;';

    var labelStyle = 'background:rgba(255,255,255,0.95);color:#2C3E50;font-size:9px;font-weight:600;padding:2px 5px;border-radius:3px;white-space:nowrap;box-shadow:0 1px 4px rgba(0,0,0,0.2);font-family:Arial,sans-serif;';

    if (!loc.labelBelow) {
      var labelTop = document.createElement('div');
      labelTop.style.cssText = labelStyle + 'margin-bottom:3px;';
      labelTop.textContent = loc.name;
      wrapper.appendChild(labelTop);
    }

    var pin = document.createElement('div');
    pin.style.cssText = 'background:' + loc.color + ';color:#fff;border-radius:50% 50% 50% 0;transform:rotate(-45deg);width:28px;height:28px;display:flex;align-items:center;justify-content:center;box-shadow:0 2px 8px rgba(0,0,0,0.35);border:2px solid #fff;';
    var num = document.createElement('span');
    num.style.cssText = 'transform:rotate(45deg);font-weight:bold;font-size:12px;line-height:1;font-family:Arial,sans-serif;';
    num.textContent = loc.number;
    pin.appendChild(num);
    wrapper.appendChild(pin);

    if (loc.labelBelow) {
      var labelBot = document.createElement('div');
      labelBot.style.cssText = labelStyle + 'margin-top:3px;';
      labelBot.textContent = loc.name;
      wrapper.appendChild(labelBot);
    }

    container.appendChild(wrapper);
  });

  var attr = document.createElement('div');
  attr.style.cssText = 'position:absolute;bottom:4px;right:6px;font-size:8px;color:#555;background:rgba(255,255,255,0.7);padding:1px 4px;border-radius:2px;z-index:20;font-family:Arial,sans-serif;';
  attr.textContent = '© OpenStreetMap contributors';
  container.appendChild(attr);
})();
</script>
</html>`;

    const blob = new Blob([html], { type: 'text/html' });
    const url = URL.createObjectURL(blob);
    const printWindow = window.open(url, '_blank');
    if (!printWindow) {
      alert('Please allow pop-ups for this site to use the print feature.');
      URL.revokeObjectURL(url);
      return;
    }
    printWindow.onload = () => {
      printWindow?.focus();
      // Give tiles a moment to load before printing
      setTimeout(() => {
        printWindow?.print();
        URL.revokeObjectURL(url);
      }, 1800);
    };
  };

  return (
    <button
      onClick={handlePrint}
      className="inline-flex items-center gap-3 border border-faded-navy text-faded-navy px-8 py-3 text-xs tracking-[0.25em] uppercase font-sans hover:bg-faded-navy hover:text-buttermilk transition-all duration-300 print:hidden"
    >
      <Printer size={14} strokeWidth={1.5} />
      Print Running Order
    </button>
  );
}
